module.exports = __webpack_public_path__ + "static/media/tools-add-blank-page.5989341a.svg";